/**
 * apply sticky functionality to .header selector
 */
import $ from 'jquery'
class Header {
  constructor(element) {
    if (!element) {
      return false
    }

    this.wrap = jQuery(element)
    this.body = jQuery('body')
    this.breakpoint = 50

    // device menu
    this.burder = jQuery('.header__burger__lnk')
    this.showMenu = false
    this.noScrollClassName = 'noscroll-devices'

    this._iniVars()

   this._toShowSubMenu(this.activeMainMenu, 0)

   this._iniMainMenu()

   this._iniSubMenu()

    this._iniMegaMenu()   

    this._showIconsLabel()


    $(window).on("scroll",()=>{        
      var scrollPos = this.headerTop.offset().top
      if(scrollPos > 0)
      this.headerTop.addClass("up")
      else
      this.headerTop.removeClass("up")                 
  })
  }

  _iniVars() {
    // delays
    this.delayMainMenuReset = 1000
    this.delaySubMenuReset = 1000
    this.delayShowSubMenu = 400
    this.delayMegaMenuReset = 1000
    this.delayShowMegaMenu = 400

    //hover timers
    this.mainMenuTimer = 0
    this.subMenuTimer = 0
    this.megaMenuTimer = 0
    this.showMegaMenuTimer = 0

    this.menuItems = this.wrap.find('.header__menu__item')
    this.activeMainMenu = this.wrap.find('.header__menu .active a')

    this.subMenu = this.wrap.find('.header__sub')
    this.subMenuItems = this.subMenu.find('.header__sub__item')
    this.activeSubMenu = this.subMenu.find('.active a')

    this.megaMenu = this.wrap.find('.header__mega')
    this.megaMenuLinks = this.wrap.find(
      '.header__top__actions a, .header__login a'
    )
    this.megaMenuItems = this.megaMenu.find('.header__mega__items')

    this.headerTop = this.wrap.find('.header__top')
  }

  /* #region main menu and submenu */
  _iniMainMenu() {
    this.menuItems
      .on('mouseover focus', (e) => {
        var item = $(e.target)

        console.log('item menu', item)

        clearTimeout(this.mainMenuTimer)
        clearTimeout(this.megaMenuTimer)

        this._hideMegaMenu()

        if (item.attr('aria-haspopup') === 'true') {
          this._setActiveMainMenu(item)

          this._toShowSubMenu(item, this.delayShowSubMenu)

          // this._resetSubMenu();
        } else {
          $('.header__sub__items', this.subMenu).removeClass('active').hide()
        }
      })
      .on('mouseout', (e) => {
        var item = $(e.target)

        this._toResetMainMenu()
        this._toHideMegaMenu()
      })
  }

  _setActiveMainMenu(lnk) {
    this._removeActiveMainMenu()
    lnk.parent().addClass('active')
  }

  _toShowSubMenu(item, delay) {
    if (item.attr('aria-haspopup') === 'true') {
      var activeSubMenu = $(`#${item.attr('aria-controls')}`)
      //$("html, body").addClass("noscroll-desktops");
      this.mainMenuTimer = setTimeout(() => {
        this._showSubMenu(activeSubMenu)
      }, delay)
    }
  }

  _showSubMenu(activeSubMenu) {
    $('.header__sub__items', this.subMenu)
      .not(activeSubMenu)
      .removeClass('active')
      .hide()
    activeSubMenu.fadeIn()

    setTimeout(() => {
      activeSubMenu.addClass('active')
    }, 10)
  }

  _removeActiveMainMenu() {
    this.menuItems.parent().removeClass('active')
  }

  _toResetMainMenu() {
    this.mainMenuTimer = setTimeout(() => {
      this._resetMainMenu()
    }, this.delayMainMenuReset)
  }

  _resetMainMenu() {
    // this._setActiveMainMenu(this.activeMainMenu);
    //this._toShowSubMenu(this.activeMainMenu, 0);
    $('.header__sub__items', this.subMenu).removeClass('active').hide()
    $('html, body').removeClass('noscroll-desktops')
  }

  /* #endregion */

  /* #region submenu */
  _iniSubMenu() {
    this.subMenu
      .on('mouseover focus', (e) => {
        var item = $(e.target)

        clearTimeout(this.mainMenuTimer)
        clearTimeout(this.megaMenuTimer)
        clearTimeout(this.subMenuTimer)
      })
      .on('mouseout', (e) => {
        this._toResetMainMenu()
        this._toResetSubMenu()
        this._toHideMegaMenu()
      })
  }

  _setActiveSubMenu(lnk) {
    this._removeActiveSubMenu()
    this._addInactiveSubMenu(lnk)
    lnk.parent().removeClass('inactive').addClass('active')
  }

  _removeActiveSubMenu() {
    this.subMenuItems.parent().removeClass('active')
  }

  _addInactiveSubMenu(lnk) {
    this.subMenuItems.not(lnk).parent().addClass('inactive')
  }

  _toResetSubMenu() {
    this.subMenuTimer = setTimeout(() => {
      this._resetSubMenu()
    }, this.delaySubMenuReset)
  }

  _resetSubMenu() {
    this._setActiveSubMenu(this.activeSubMenu)
    this.subMenuItems.parent().removeClass('inactive')
  }
  /* #endregion */

  /* #region megaMenu */
  _iniMegaMenu() {
    this.megaMenuLinks
      .on('mouseover focus', (e) => {
        var item = $(e.target)

        clearTimeout(this.mainMenuTimer)
        clearTimeout(this.megaMenuTimer)
        clearTimeout(this.subMenuTimer)
        clearTimeout(this.showMegaMenuTimer)

        console.log('mouse over')

        //this._subRemoveActive();
        this._toResetMainMenu()

        //this._hideSideMenu();

        //   this._setActiveSubMenu(item);

        if (
          item.attr('aria-haspopup') &&
          item.attr('aria-haspopup') === 'true'
        ) {
          this._toShowMegaMenu(item)
        } else {
          this._hideMegaMenu()
        }
      })
      .on('mouseout', (e) => {
        var item = $(e.target)
    
        this._toHideMegaMenu()
      })

    this.megaMenu
      .on('mouseover', (e) => {
        clearTimeout(this.mainMenuTimer)
        clearTimeout(this.megaMenuTimer)
        clearTimeout(this.subMenuTimer)
        clearTimeout(this.showMegaMenuTimer)
      })
      .on('mouseout', (e) => {
        
        this._toHideMegaMenu()
      })
  }

  _toShowMegaMenu(item, delay) {
    if (item.attr('aria-haspopup') === 'true') {
      var activeMegaMenu = $(`#${item.attr('aria-controls')}`)

      if (activeMegaMenu.length) {
        this.showMegaMenuTimer = setTimeout(() => {
          this._showMegaMenu(activeMegaMenu)
        }, this.delayShowMegaMenu)
      } else {
        this._hideMegaMenu()
      }
    }
  }

  _showMegaMenu(activeMegaMenu) {
    if (this.megaMenu.hasClass('active')) {
      this.megaMenu.show()
      this.wrap.addClass('mega-menu-opened')
      this._showMegaMenuItem(activeMegaMenu)
      //$("html, body").addClass("noscroll-desktops");
    } else {
      this._showMegaMenuItem(activeMegaMenu)
      this.wrap.addClass('mega-menu-opened')
      this.megaMenu.slideDown(250, 'linear', () => {
        this.megaMenu.addClass('active')
        //$("html, body").addClass("noscroll-desktops");
      })
    }
  }

  _showMegaMenuItem(activeMegaMenu) {
    this._hideMegaMenuItems(activeMegaMenu)
    activeMegaMenu.show()
  }

  _hideMegaMenuItems(activeMegaMenu) {
    this.megaMenuItems.not(activeMegaMenu).hide()
    //$("html, body").removeClass("noscroll-desktops");
  }

  _toHideMegaMenu() {
    clearTimeout(this.showMegaMenuTimer)

    this.megaMenuTimer = setTimeout(() => {
      this._hideMegaMenu()
    }, this.delayMegaMenuReset)
  }

  _hideMegaMenu() {
    this._hideMegaMenuItems()
    this.megaMenu.removeClass('active').hide()
    this.wrap.removeClass('mega-menu-opened')
  }
  /* #endregion */

  _showIconsLabel() {
    var items = this.wrap.find('.header__top__actions__anim') 

    items.each(function () {
      $(this).mouseenter(function () {
        $(this).addClass('expand')
        $(this).find('a:first-child').addClass('blue')
      })

      $(this).mouseleave(function () {
        $(this).removeClass('expand')
        $(this).find('a:first-child').removeClass('blue')
      })
    })
  }
}
export default Header
